export default class Listener {
  listeners: Record<string, Record<string, (value: any) => void>> = {}

  addListener(event: string, listenerObj: string, cb: (value: any) => void) {
    if (!this.listeners[event]) this.listeners[event] = {}
    this.listeners[event][listenerObj] = cb
  }

  has(event: string) {
    return !!this.listeners[event]
  }

  execute(event: string, value: string) {
    if (!this.listeners[event]) return
    Object.values(this.listeners[event]).forEach((cb) => cb(value))
  }
}
